require('../../../libs/backbone/backbone.ajaxq.adapter.ts');
var Handlebars = require('handlebars');

var Template = require('text-loader!../../templates/queue_monitor_templates/queue_counters_monitor.template.htm');
var Pagination = require('../../views/pagination.view.ts');
var i18n = require('l10n');

require('../../../libs/jquery-dynamicFontSize/jquery-dynamicFontSize.js');

var TheView = Backbone.View.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	pagination: {},
	autoRefreshTimer: null,
    intervalTimes: {
        "el": 10000,
        "en": 3000
    },
	initialize: function (options) {
	    var self = this;

        $(window).off("popstate").on("popstate", function() {
            self.clearTimeout();
        });

        this.clearTimeout();

        this.startAutoRefreshTimer();
	},
	superRender: Backbone.View.prototype.render,
    render: function() {

        this.$el.html(this.template( {queueCollection: this.queue, pagination: this.pagination, counters: this.countersToShow} ));
    },
	events:{

	},
	data: function(collection) {
	console.log(collection)

	    if(this.autoRefreshTimer == null)
	        this.startAutoRefreshTimer();

	    if( collection == null) {
	        this.queue = collection;
	        this.render();
	        return ;
	    }

        this.queue = collection[0];
        this.createPagination(this.queue.countersInfo);
        this.render();
	},
	updateQueue: function(queue) {
	    this.queue = queue;
	    this.openedCounters = this.getOpenedCounters(queue.countersInfo);
	    this.pagination.totalPages = Math.ceil(this.openedCounters.length/this.pagination.pageSize);
	    this.updateList();

	    this.render();
	},
	updateLessInfo: function(info) {

	},
    createPagination: function(counters) {
        this.openedCounters = this.getOpenedCounters(counters);

        var pageSize = 5;
        var totalPages = Math.ceil(this.openedCounters.length/pageSize);

        this.pagination = {
            "pageSize": pageSize,
            "totalPages": totalPages,
            "currentPage": 1
        }

        this.updateList();
    },
    getNextPage: function() {
        if (this.pagination.currentPage < this.pagination.totalPages) {
            this.pagination.currentPage += 1;
        } else {
            this.pagination.currentPage = 1;
        }
        this.updateList();
        this.render();
        this.startAutoRefreshTimer();
    },
    updateList: function() {
        var end = (this.pagination.currentPage * this.pagination.pageSize);
        var start = (end - this.pagination.pageSize);
        pagedResults = this.openedCounters.slice(start, end);

       this.countersToShow = pagedResults;
    },
    getOpenedCounters: function(counters) {

        counters = $.map( counters, function( value, index ) {
          if(value.counter.status == "Open") return value;
        });

        return counters;
    },
    startAutoRefreshTimer: function() {
        var self = this;

        var intervalTime = this.intervalTimes[i18n.lng()];

        this.autoRefreshTimer = setTimeout(function() {
            self.toggleLanguage();
        }, intervalTime);
    },
    toggleLanguage: function() {
        if (this.pagination.currentPage == this.pagination.totalPages) {
            var lang = i18n.lng();
            lang = lang == "el" ? "en" : "el";
            i18n.setLng(lang);

            this.getNextPage();
            return;
        }

        this.getNextPage();
    },
    clearTimeout: function() {
        if(this.autoRefreshTimer) {
            clearTimeout(this.autoRefreshTimer);
            this.autoRefreshTimer = null;
        }
    },
    destroy: function() {
        this.clearTimeout();
    }
});

module.exports = TheView;